'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, ButtonGroup, Datepicker, Drawer, Heading, TextField, TextPassage } from '@petsmart-ui/sparky';
import Cookies from 'js-cookie';
import moment, { type Moment } from 'moment';
import { type InputEvent, useState } from 'react';
import invariant from 'tiny-invariant';
import { config } from './config';
import { dateToAz, validateTime } from './utils';
import './PreviewDrawer.scss';
interface SitePreviewDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  previewDate?: string;
}
export function PreviewDrawer(t0) {
  const $ = _c(42);
  const {
    previewDate,
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== previewDate) {
    t1 = () => {
      if (previewDate) {
        return moment(dateToAz(previewDate));
      }
      return null;
    };
    $[0] = previewDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [date, setDate] = useState(t1);
  let t2;
  if ($[2] !== date) {
    t2 = date?.format("HH:mm");
    $[2] = date;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [time, setTime] = useState(t2);
  let t3;
  if ($[4] !== time) {
    t3 = newDate => {
      setDate(newDate);
      if (!time) {
        setTime("00:00");
      }
    };
    $[4] = time;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onDateChange = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = t5 => {
      const {
        currentTarget
      } = t5;
      if (validateTime(currentTarget.value)) {
        setTime(currentTarget.value);
      }
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const onTimeChange = t4;
  const removePreviewParam = _temp;
  let t5;
  if ($[7] !== onClose) {
    t5 = () => {
      setDate(null);
      setTime(undefined);
      Cookies.remove("x-petm-preview");
      removePreviewParam();
      globalThis.location.reload();
      onClose();
    };
    $[7] = onClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onReset = t5;
  let t6;
  if ($[9] !== date || $[10] !== onClose || $[11] !== time) {
    t6 = () => {
      invariant(date && time, "date && time must be a defined");
      const [hours, minutes] = time.split(":");
      date.set({
        hour: Number.parseInt(hours, 10),
        minute: Number.parseInt(minutes, 10)
      });
      Cookies.set("x-petm-preview", JSON.stringify({
        previewDate: date.format("YYYY-MM-DDTHH:mm:ss-07:00")
      }));
      removePreviewParam();
      globalThis.location.reload();
      onClose();
    };
    $[9] = date;
    $[10] = onClose;
    $[11] = time;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const onPreview = t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Drawer.Header><Heading tagName="h3">Site Preview</Heading></Drawer.Header>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <TextPassage>Date / Time</TextPassage>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== date || $[16] !== onDateChange) {
    t9 = <Datepicker date={date} label="Date" placeholder="" numberOfMonths={1} onDateChange={onDateChange} isOutsideRange={_temp2} withFullScreenPortal={false} />;
    $[15] = date;
    $[16] = onDateChange;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== date || $[19] !== time) {
    t10 = time ?? date?.format("HH:mm");
    $[18] = date;
    $[19] = time;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <TextField label="Time" mask={config} defaultValue={t10} onInput={onTimeChange} />;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9) {
    t12 = <div className="site-preview-pickers">{t9}{t11}</div>;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <TextPassage className="site-preview-description">Time in: Arizona/Phoenix</TextPassage>;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12) {
    t14 = <Drawer.Body>{t8}{t12}{t13}</Drawer.Body>;
    $[27] = t12;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== onReset) {
    t15 = <Button text="Reset" onClick={onReset} fullWidth={true} />;
    $[29] = onReset;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const t16 = !date;
  let t17;
  if ($[31] !== onPreview || $[32] !== t16) {
    t17 = <Button text="Preview" variant="primary" onClick={onPreview} disabled={t16} fullWidth={true} />;
    $[31] = onPreview;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t15 || $[35] !== t17) {
    t18 = <Drawer.Footer><ButtonGroup>{t15}{t17}</ButtonGroup></Drawer.Footer>;
    $[34] = t15;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== isOpen || $[38] !== onClose || $[39] !== t14 || $[40] !== t18) {
    t19 = <Drawer isActive={isOpen} onClose={onClose}>{t7}{t14}{t18}</Drawer>;
    $[37] = isOpen;
    $[38] = onClose;
    $[39] = t14;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  return t19;
}
function _temp2() {
  return false;
}
function _temp() {
  const url = new URL(globalThis.location.href);
  url.searchParams.delete("_preview");
  globalThis.history.replaceState(null, "", url);
}